import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseProductShield() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      name: isEmpty(state.name),
    };

    setter(errorState);

    if (errorState.name) {
      enqueueSnackbar("لطفا اطلاعات محفظه را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getShieldList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Shields?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };
  const getAllShieldList = (callback) => {
    MyAxios.get(`Admin_Shields?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getShieldByID = (id, callback) => {
    MyAxios.get(`Admin_Shields/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateShield = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Shields`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محفظه با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addShield = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Shields`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محفظه با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteShield = (id, callback) => {
    const data = new FormData();
    data.append("ShieldID", id);
    MyAxios.delete(`Admin_Shields`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محفظه با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getAllShieldList,
    getShieldList,
    getShieldByID,
    validate,
    updateShield,
    addShield,
    deleteShield,
  };
}
